'use es6';

import { logAndReportError } from './core/errors';
import * as superStore from './core/store';
import * as client from './client';
import * as constants from './constants';
export function createClient({
  onError = logAndReportError,
  store = superStore.getDefaultStore(),
  // This allows to override the feature flags from the cache. When `laboratory-lib` makes requests to the network
  // It will then replace the overrides from the queryString into the result.
  search = window.location.search,
  timeout = constants.TIMEOUT_DEFAULT,
  quickFetchLabel = null,
  // Attempts to use `window.quickFetch` by default and falls-back to dynamic module import
  // Since if window.quickFetch is not defined, well, even if the module is available, pretty much it should not work
  quickFetch = window.quickFetch || null,
  treatments = null,
  identifiers = null,
  experiments = null,
  // Attempts to not use `hub-http` by default and falls-back to dynamic module import
  http = null,
  apiDomain = '',
  // Makes laboratory-lib to not execute any network request under any circumstance.
  useCacheOnly = false,
  // `ceid`'s are copy experiment identifiers. These are necessary to flag a request as to retrieve all
  // the copy experiments for a given application. This feature is going to be deprecated.
  // See https://git.hubteam.com/HubSpot/Hublytics/issues/2706 for more details.
  ceid = ''
} = {}) {
  return client.createClient({
    onError,
    store,
    search,
    timeout,
    http,
    quickFetchLabel,
    quickFetch,
    treatments,
    identifiers,
    experiments,
    apiDomain,
    useCacheOnly,
    ceid
  });
}